import React from 'react'
import { RewardProgramDetailsDto } from '@/api/Trading-Accounts/Types/RewardProgramDto'
import { NavigationHeader } from '@/components/NavigationHeader/NavigationHeader'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { RewardProgramTab } from '@/routes/Marketing/RewardsHub/RewardPrograms/ResolveRewardPrograms'
import { useTabNavigate } from 'hooks/useTabNavigate'

interface Props {
  data: RewardProgramDetailsDto
  tab: RewardProgramTab
}

export const RewardProgramNavigation: React.FC<Props> = (props) => {
  const tabNavigate = useTabNavigate()

  return (
    <div>
      <NavigationHeader />
      <Tabs value={props.tab} onValueChange={tabNavigate} className='mt-2'>
        <TabsList>
          <TabsTrigger value={RewardProgramTab.DETAILS}>Details</TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  )
}
